import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// AssetMaster
import BaseMixer from "../../BaseMixer";
import { WorkViewModule } from "@/store/modules/workView.module";
let WeekViewProjectEntryComponent = /** @class */ (() => {
    let WeekViewProjectEntryComponent = class WeekViewProjectEntryComponent extends Mixins(BaseMixer) {
        get projectModeUsers() {
            return WorkViewModule.weekViewProjectModeUsers;
        }
        get projectModeProjects() {
            return WorkViewModule.weekViewProjectModeProjects;
        }
        created() { }
    };
    WeekViewProjectEntryComponent = __decorate([
        Component({
            name: "WeekViewProjectEntryComponent",
            components: {},
        })
    ], WeekViewProjectEntryComponent);
    return WeekViewProjectEntryComponent;
})();
export default WeekViewProjectEntryComponent;
